import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var TextTable = require("components/reading/books/TextTable");
var ItemHeader = require("components/data/subjects/shared/ItemHeader");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var Spinner = require("components/utility/Spinner");
var EmptyState = require("components/data/EmptyState");
var TruncatedDataNote = require("components/data/TruncatedDataNote");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "textVariety", "textID", "userIDs"
	);

	conditions.timeKey = "last_active_by_user_id";

	return conditions;
}

@connect(
	(state, props) => ({
		loading: ReadingSelectors.isLoadingBooks({ state }),
		books: ReadingSelectors.books({
			state,
			conditions: propsToConditions(props)
		}),
		showLogs: Features.isEnabled(Features.LOG_READING),
		showDigitalActivities: Features.isEnabled(Features.DIGITAL_EXERCISES)
	}),
	(dispatch, props) => ({
		populateData: () => {
			// TODO: standardize FE requests
			// if the dataset of students is large, send multiple requests
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID")
				var actionFunction = ReadingActions.fetchBookActivity
				var options = { embeds: ["book.quiz_evaluations", "book.log_sums"], cache: true, fetchDetails: !props.skipPreloadDetails }
				return new Promise(function (resolve, reject) {
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, (results) => {
						resolve(results);
					})
				}).catch(() => console.log("Book activity failed to load"))
			} else {
				return dispatch(ReadingActions.fetchBookActivity({
					userID: CurrentUser.get().id,
					conditions: propsToConditions(props),
					embeds: ["book.quiz_evaluations", "book.log_sums"],
					fetchDetails: !props.skipPreloadDetails,
					cache: true
				}));
			}
		}
	})
)
@providePopulateData()
class DataTextTables extends React.Component {
	constructor(props) {
		super();
		autobind(this);

	}

	render() {
		if (this.props.byStudent) {
			var textTables = []
			var studentsWithoutBooks = []
			var booksTotal = 0;
			_.each(this.props.userIDs, (studentID) => {
				var books = _.select(this.props.books, (book) => {
					return _.includes(book.user_ids, studentID)
				});

				booksTotal += books.length;

				if (!this.props.showFullData) {
					books = _.first(books, 3)
				}

				if (books.length > 0) {
					textTables.push(
						<div key={ studentID }>
							<ItemHeader studentID={ studentID } pageBreak />
							<TextTable books={ books } userID={ studentID }
								showLogStats={ this.props.showLogs }
								softMax={ this.props.softMaxPerTable }
								showResponseCounts={ this.props.showDigitalActivities } />
						</div>
					)
				} else {
					studentsWithoutBooks.push(studentID)
				}
			})
			if (studentsWithoutBooks.length > 0) {
				if (this.props.showFullData) {
					var noTables = <NoActivityBlock userIDs={ studentsWithoutBooks } contentType="Books" />
				} else {
					if (_.isEmpty(textTables)) {
						var noTables = <NoActivityBlock userIDs={ studentsWithoutBooks } contentType="Books" />	
					}
				}
			}
			if (this.props.showFullData) {
				var textTables = textTables
			} else {
				if (textTables.length > 0) {
					var truncatedRow = <TruncatedDataNote total={ booksTotal } type={ BOOKS } />
				}
				var textTables = textTables[0]
			}
			var display = (
				<div>
					{ textTables }
					{ noTables }
					{ truncatedRow }
				</div>
			)
		} else {
			var books = _.sortBy(this.props.books, "max_last_active").reverse();
			if (books.length > 0) {
				if (this.props.booksAmount) {
					books = _.first(books, this.props.booksAmount)
				}
				var display = (
					<TextTable books={ books }
						showLogStats={ this.props.showLogs }
						softMax={ this.props.softMaxPerTable }
						showResponseCounts={ this.props.showDigitalActivities }
						showStudentCell />
				);
			} else {
				var emptyState = <EmptyState type={ BOOKS } />
			}
		}
		return (
			<div className="dataTextTables">
				{ emptyState } 
				{ display }
			</div>
		)
	}
}
var BOOKS = "books";
DataTextTables.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showFullData: PropTypes.bool,
	textVariety: PropTypes.string,

	byStudent: PropTypes.bool,
	booksAmount: PropTypes.number,
	showLogs: PropTypes.bool,
	showDigitalActivities: PropTypes.bool,
	skipPreloadDetails: PropTypes.bool,
	softMaxPerTable: PropTypes.number,

	// Data from @connect
	loading: PropTypes.bool,
	books: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataTextTables;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataTextTables.js